import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MatSelect } from '@angular/material';
import { CIDService } from 'src/app/services/common/cid.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { TranslateService } from '@ngstack/translate';
import { SubsidiaryCompanyService } from 'src/app/services/http/business/subsidiary/subsidiary-company.service';
import { SubsidiaryCompanyEntryComponent } from '../subsidiary-company-entry/subsidiary-company-entry.component';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SnackBarService } from 'src/app/services/common/snackBar.service';

@Component({
  selector: 'app-subsidiary-company-list',
  templateUrl: './subsidiary-company-list.component.html',
  styleUrls: ['./subsidiary-company-list.component.css']
})
export class SubsidiaryCompanyListComponent implements OnInit {

  compnayList=[];
  isOwner: boolean;
  filter= {
    CustomerName: null
  };
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "customerTitle",
    "management",
    "provinceCity",
    "area",
    "status",
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  //snackBar: any;

  constructor(
      private dialog: MatDialog,
      private cidService: CIDService,
       private snackBar: SnackBarService,
      private holdingService: HoldingService,
      private companyService: CompanyService,
      public translate: TranslateService,
      private subsidiaryCompanyService: SubsidiaryCompanyService
      //    private errorService: ErrorsService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.refresh();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }


  refresh() {
    this.subsidiaryCompanyService.getCustomerList(this.filter).subscribe(
      res => {

        this.paginator.pageSize = 10;
        this.paginator.length = res.Total;
        this.pageIndex = 0;
        this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }


  activeDeactive(data: any): void {

    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive
        ? this.translate.get("confirm.inActive", {
          name: this.translate.get("label.subsidiaryCompany") + " " + "'" + data.CustomerTitle + "'"
        })
        : this.translate.get("confirm.active", {
          name: this.translate.get("label.subsidiaryCompany") + " " + "'" + data.CustomerTitle + "'"
        }),
        alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      var model: any = {
        CustomerId: data.Id,
        IsActive: !data.IsActive
      };
      if (result) {

        this.subsidiaryCompanyService.customerActiveDeactive(model).subscribe(
          () => {
            if (!model.IsActive) {
              this.snackBar.OpenSnackBar(
                this.translate.get("success.customerDeactive"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
            else {
              this.snackBar.OpenSnackBar(
                this.translate.get("success.customerActive"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
            this.refresh();
          },
          () => {
            if (!model.IsActive) {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.customerDeactive"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
            else {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.customerActive"),
                "ok",
                5000,
                SoundEnum.beep
              );
            }
          }
        );
      }
    });
  }

  paginatorEvent(event) {
    this.subsidiaryCompanyService.getCustomerList(this.filter,event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.paginator.length = res.Total;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
      });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.refresh();
  }


  addCustomer() {
    this.dialog
      .open(SubsidiaryCompanyEntryComponent, {
        minWidth: "850px",
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      });
  }
  editCustomer(params: any) {
    // let model: any;
      this.dialog.open(SubsidiaryCompanyEntryComponent, {
        minWidth: "850px",
          disableClose: true,
          data: params
        })
        .afterClosed()
        .subscribe(() => {
          this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
        });
  }

}
